// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  recipeId: __t.u64().primaryKey().name("recipe_id"),
  orgId: __t.u64().name("org_id"),
  name: __t.string(),
  notes: __t.string(),
  autonomyLevel: __t.string().name("autonomy_level"),
  seatsJson: __t.string().name("seats_json"),
  watchersJson: __t.string().name("watchers_json"),
  originWorkspaceId: __t.u64().name("origin_workspace_id"),
  createdAt: __t.i64().name("created_at"),
});
